<template>
  <div class="moped">
    <div class="title">我的助力团</div>
    <div class="content_padding">
      <div class="content">
        <div class="tabs flex">
          <p
            :class="[ item.id == tur ? 'active' : '']"
            v-for="item in tabs"
            :key="item.id"
            @click="tabSelect(item.id)"
          >{{item.name}}</p>
        </div>
        <div class="time_list" @scroll="scrollEvent">
          <div class="flex list" v-for="item in behaviorsList" :key="item.id">
            <div class="flex content_alitem">
              <img :src="item.avatar" alt />
              <div class="content_center">
                <p class="title_name">{{item.nick_name}}</p>
                <p class="content_msg">{{item.msg}}</p>
              </div>
            </div>
            <p class="num">+1</p>
          </div>
          <div class="loading">{{ isData ? '暂无更多数据' : '加载中~~'}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { id: 0, name: '全部' },
        { id: 1, name: '查看分享' },
        { id: 2, name: '购买商品' },
      ],
      tur: 0,
      behaviorsList: [],
      rankId: '',
      isData: false,
      page: 1,
    }
  },
  created() {
    this.rankId = this.$route.query.id
  },
  mounted() {
    this.getBehaviorsList()
  },
  methods: {
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight ==
        e.srcElement.scrollHeight
      ) {
        if (this.isData) return
        this.page++
        this.getBehaviorsList()
        console.log('嘿嘿我在底部触发了')
      }
    },
    async getBehaviorsList() {
      let res = await this.http('Rank.behaviorsList', {
        page: this.page,
        limit: 20,
        rank_id: this.rankId,
        type: this.tur,
      })
      console.log(res)
      this.behaviorsList = [...this.behaviorsList, ...res.content.list]
      this.isData = res.content.count == this.behaviorsList.length
    },
    tabSelect(id) {
      let flag = false
      if (flag) return
      flag = true
      this.behaviorsList = []
      this.page = 1
      this.tur = id
      this.getBehaviorsList()
      flag = false
    },
  },
}
</script>

<style scoped lang="scss">
.active {
  background: linear-gradient(61deg, #fff4ed 0%, #ffe4d7 100%);
  border-radius: 20px 20px 0px 0px;
}
.content_alitem {
  align-items: flex-start;
}
// 加载中
.loading {
  text-align: center;
  line-height: 40px;
  padding: 20px 0;
}
.num {
  font-size: 42px;
  color: #fa4c13;
  line-height: 59px;
}
.moped {
  height: 100vh;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/bgg_yj_tyb.png')
    no-repeat center;
  background-size: 100% 100%;
  .title {
    padding: 43px 0 32px 0;
    text-align: center;
    font-size: 38px;
    font-weight: bold;
    color: #ffffff;
  }
  .content_padding {
    padding: 0 18px;
    .content {
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      .tabs {
        font-size: 30px;
        color: #ff551a;
        justify-content: space-between;
        p {
          width: 100%;
          text-align: center;
          padding: 18px 0;
        }
      }
      .time_list {
        height: 70vh;
        padding: 0 40px;
        margin-top: 42px;
        margin-bottom: 20px;
        overflow: hidden;
        overflow-y: scroll;
        .list {
          width: 100%;
          padding: 20px 0;
          border-bottom: 1px solid rgba(238, 238, 238, 1);
          justify-content: space-between;
          align-items: center;
          img {
            width: 88px;
            height: 88px;
            border-radius: 50%;
            margin-right: 20px;
          }
          .content_center {
            flex: 1;
            .title_name {
              font-size: 30px;
              line-height: 42px;
              color: #333333;
              width: 384px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .content_msg {
              font-size: 26px;
              color: #9c9c9c;
              line-height: 37px;
            }
          }
        }
      }
    }
  }
}
</style>